interface GetReportExpirationArgs {
  finishedOn?: string | null;
  resultValidityDays?: number;
}

export interface IReportExpiration {
  isExpired: boolean;
  completedOn: Date | null;
  resultValidityDays: number;
}

export function getReportExpiration({
  finishedOn,
  resultValidityDays = 365,
}: GetReportExpirationArgs): IReportExpiration {
  if (!finishedOn) {
    return { isExpired: false, completedOn: null, resultValidityDays };
  }

  const completedOn = new Date(finishedOn);
  const expiresOn = new Date(completedOn);
  expiresOn.setDate(expiresOn.getDate() + resultValidityDays);

  return {
    isExpired: new Date() >= expiresOn,
    completedOn,
    resultValidityDays,
  };
}
